export const LOAD_REQUEST = "users::load::request";
export const LOAD_COMPLETE = "users::load:complete";
export const ACCEPT = "users::accept";
export const ADD = "users::add";
export const BLOCK = "users::block";
export const REQUEST_ACCESS = "users::request::access";
